/** @jsxRuntime classic */
/** @jsx jsx */
import { memo, useRef, forwardRef, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { jsx, css } from '@emotion/core';
import { Typography } from "../";
const ListItemText = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  className,
  children,
  style,
  refs,
  ...props
}, ref) => {
  if (!ref) {
    ref = useRef(null);
  }
  const ListItemTextRoot = css`
        display: flex;
        flex: 1 1 auto;
        position: relative;
        align-items: center;
        background-color: inherit;
        box-sizing: border-box;
        order: 2;
    `;
  useEffect(() => {
    if (refs) refs(ref);
  }, []);
  const ListItemTextView = useMemo(() => jsx("div", {
    css: ListItemTextRoot,
    className: 'DGN-UI-List-Item-Text ' + className,
    ref: ref,
    style: style,
    ...props
  }, jsx(Typography, null, children)), [children]);
  return ListItemTextView;
}));
ListItemText.defaultProps = {
  className: ''
};
ListItemText.propTypes = {
  /** class for ListItemText */
  className: PropTypes.string,
  /** the function to get ref of ListItemText */
  refs: PropTypes.func,
  /** style inline of ListItemText */
  style: PropTypes.object,
  /** content to display in ListItem */
  children: PropTypes.node
};
export default ListItemText;